import { useMemo } from 'react';
import { ethers } from 'ethers';
import { useWallet } from '../context/WalletContext';
import { getLogicContract, getStorageContract, getUsdtContract } from '../utils/contract';
import { CURRENT_NETWORK } from '../config/network';

// Returns contract instances. Uses signer when connected, else falls back to a public read-only provider.
// Uses useMemo — depends only on signer identity + wrongNetwork flag; never causes render loops.
export const useContracts = () => {
  const { signer, provider, wrongNetwork } = useWallet();

  return useMemo(() => {
    // Use signer when connected on correct network, else a read-only fallback provider
    let signerOrProvider;
    if (signer && !wrongNetwork) {
      signerOrProvider = signer;
    } else if (provider && !wrongNetwork) {
      signerOrProvider = provider;
    } else {
      // Read-only fallback — public RPC
      signerOrProvider = new ethers.providers.JsonRpcProvider(CURRENT_NETWORK.rpcUrls[0]);
    }

    return {
      logic: getLogicContract(signerOrProvider),
      storage: getStorageContract(signerOrProvider),
      usdt: getUsdtContract(signerOrProvider)
    };
  }, [signer, provider, wrongNetwork]);
};
